import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  settingsContainer: {
    height: "calc(100% - 128px)",
    display: "flex",
    lineHeight: 1.4,
    padding: "15px",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      padding: "30px 32px 32px",
    },
    "& .MuiContainer-root": {
      "& .loading-container": {
        zIndex: 2,
      },
    },
    "& .MuiOutlinedInput-input:not(textarea)": {
      padding: "6.5px 14px",
      paddingRight: "30px",
      lineHeight: 1.9,
      fontSize: 14,
      height: 28,
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      color: "#484a56",
    },
    "& h3": {
      height: 28,
      fontSize: 20,
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.4,
      letterSpacing: "normal",
      color: theme.palette.text.primary,
    },
    "& .btn-ctn": {
      marginBottom: 20,
      width: "100%",
    },
    "& .flex-ctn": {
      display: "flex",
    },
    "& .mic-cam-check-container": {
      paddingTop: 0,
    },
    "& .settingsLeftMenuSelector": {
      padding: "0 1rem",
    },
  },
  tabPanelWrapper: {
    margin: "0px",
    padding: "12px 0px 12px 75px !important",
    maxWidth: "1130px",
  },
}));
